"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var GameplayForm_1 = __importDefault(require("@components/Forms/GameplayForm/GameplayForm"));
var react_1 = require("react");
var GameplayList_1 = __importDefault(require("@components/Lists/GameplayList/GameplayList"));
var react_redux_1 = require("react-redux");
var gameplaySlice_1 = require("@store/slices/gameplaySlice");
var modalSlice_1 = require("@store/slices/modalSlice");
var modalSlice_2 = require("@store/slices/modalSlice");
var style = __importStar(require("./styles/GameplayView.module.scss"));
var useCurrentLanguage_1 = require("@hooks/useCurrentLanguage");
var gameplayFormTranslator_1 = require("@components/Forms/GameplayForm/localisation/gameplayFormTranslator");
var gameplayAPI_1 = require("@services/gameplayAPI");
var loaderSlice_1 = require("@store/slices/loaderSlice");
var initialFormData = {
    id: "",
    // gddId: "",
    story: "",
    objectives: [],
    progressions: [],
    difficulty: "",
    pacing: "",
    player_experience: "",
};
function GameplayView() {
    var gameplay = (0, react_redux_1.useSelector)(function (state) { return state.gameplaySlice; }).gameplay;
    var _a = (0, react_1.useState)(gameplay), formData = _a[0], setFormData = _a[1];
    var gddId = (0, react_redux_1.useSelector)(function (state) { return state.gddSlice.gdd; }).id;
    var dispatch = (0, react_redux_1.useDispatch)();
    var currentLang = (0, useCurrentLanguage_1.useCurrentLanguage)();
    var loc = gameplayFormTranslator_1.gamplayFormTranslator[currentLang];
    function handleFormSubmit() {
        return __awaiter(this, void 0, void 0, function () {
            var id, data, res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = formData.id, data = __rest(formData, ["id"]);
                        dispatch((0, loaderSlice_1.setLoading)(true));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, (0, gameplayAPI_1.updateGameplayAPI)(data, gddId)];
                    case 2:
                        res = _a.sent();
                        if (res.success) {
                            dispatch((0, gameplaySlice_1.editGameplay)(res.gameplay));
                            dispatch((0, modalSlice_1.showModal)({ activeModal: modalSlice_2.ActiveModal.Info, text: loc.save }));
                        }
                        else {
                            dispatch((0, modalSlice_1.showModal)({ activeModal: modalSlice_2.ActiveModal.Info, text: res.message }));
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        dispatch((0, modalSlice_1.showModal)({
                            activeModal: modalSlice_2.ActiveModal.Info,
                            text: "something went wrong",
                        }));
                        return [3 /*break*/, 5];
                    case 4:
                        dispatch((0, loaderSlice_1.setLoading)(false));
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function deleteObjective(item) {
        var filteredObjectives = formData.objectives.filter(function (obj) { return obj.id !== item.id; });
        setFormData(function (prev) {
            return __assign(__assign({}, prev), { objectives: filteredObjectives });
        });
    }
    function deleteProgression(item) {
        var filteredProgressions = formData.progressions.filter(function (obj) { return obj.id !== item.id; });
        setFormData(function (prev) {
            return __assign(__assign({}, prev), { progressions: filteredProgressions });
        });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: style.container, children: [(0, jsx_runtime_1.jsx)("div", { className: style.gameplay_form, children: (0, jsx_runtime_1.jsx)(GameplayForm_1.default, { t: loc, handleFormSubmit: handleFormSubmit, formData: formData, setFormData: setFormData }) }), (0, jsx_runtime_1.jsxs)("div", { className: style.gameplay_list_container, children: [(0, jsx_runtime_1.jsx)(GameplayList_1.default, { deleteItem: function (item) { return deleteObjective(item); }, title: "".concat(loc.objectives, ":"), item: formData.objectives, renderItem: function (item) { return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: item.name }); } }), (0, jsx_runtime_1.jsx)(GameplayList_1.default, { deleteItem: function (item) { return deleteProgression(item); }, title: "".concat(loc.progression, ":"), item: formData.progressions, renderItem: function (item) { return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: item.name }); } })] })] }));
}
exports.default = GameplayView;
